<template>
    <div>
        <div class="ns--sf-table-container ns--sf-week-tbl">
            <el-table v-loading="table_loading" :data="computedTableData" style="width: 100%; max-width: 100%; overflow-x: auto;" class="ns-table" :header-cell-class-name="setCellClass">
                <el-table-column label="LAST YEAR - ACTUAL" >
                    <el-table-column prop="l_y_week_name" label="WEEK" width="250"></el-table-column>
                    <el-table-column :prop="selected_forecast_view === 'sales' ? 'prev_year_actual_sales' : 'prev_year_actual_lab_hrs'" :label="selected_forecast_view === 'sales' ? 'SALES' : 'LABOUR HRS'">
                        <template slot-scope="scope">
                            <span>{{ selected_forecast_view === 'sales' ? formatCurrency(scope.row.prev_year_actual_sales) : scope.row.prev_year_actual_lab_hrs }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :prop="selected_forecast_view === 'sales' ? 'prev_year_actual_transactions' : 'prev_year_actual_lab_cost'" :label="selected_forecast_view === 'sales' ? 'TRANSACTIONS' : 'LABOUR COST'" width="160">
                        <template slot-scope="scope">
                            <span>{{ selected_forecast_view === 'sales' ? scope.row.prev_year_actual_transactions : formatCurrency(scope.row.prev_year_actual_lab_cost) }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="LAST WEEK - ACTUAL">
                    <el-table-column prop="prev_week_name" label="WEEK" width="250"></el-table-column>
                    <el-table-column :prop="selected_forecast_view === 'sales' ? 'prev_week_actual_sales' : 'prev_week_actual_lab_hrs'" :label="selected_forecast_view === 'sales' ? 'SALES' : 'LABOUR HRS'">
                        <template slot-scope="scope">
                            <span>{{ selected_forecast_view === 'sales' ? formatCurrency(scope.row.prev_week_actual_sales) : scope.row.prev_week_actual_lab_hrs }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :prop="selected_forecast_view === 'sales' ? 'prev_week_actual_transactions' : 'prev_week_actual_lab_cost'" :label="selected_forecast_view === 'sales' ? 'TRANSACTIONS' : 'LABOUR COST'" width="160">
                        <template slot-scope="scope">
                            <span>{{ selected_forecast_view === 'sales' ? scope.row.prev_week_actual_transactions : formatCurrency(scope.row.prev_week_actual_lab_cost) }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="FORECAST">
                    <el-table-column prop="forecast_week" label="WEEK" width="250">
                        <template slot-scope="scope">
                            <span class="text-amplitude font-semibold cursor-pointer" @click="handleDateClick('day', scope.row.forecast_week)">{{ scope.row.forecast_week }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :prop="selected_forecast_view === 'sales' ? 'curr_actual_sales' : 'curr_actual_lab_hrs'" :label="selected_forecast_view === 'sales' ? 'SALES' : 'LABOUR HRS'">
                        <template slot-scope="scope">
                            <span>{{ selected_forecast_view === 'sales' ? formatCurrency(scope.row.curr_forecast_sales) : scope.row.curr_forecast_lab_hrs }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :prop="selected_forecast_view === 'sales' ? 'curr_actual_transactions' : 'curr_actual_lab_cost'" :label="selected_forecast_view === 'sales' ? 'TRANSACTIONS' : 'LABOUR COST'" width="160">
                        <template slot-scope="scope">
                            <span>{{ selected_forecast_view === 'sales' ? scope.row.curr_forecast_transactions : formatCurrency(scope.row.curr_forecast_lab_cost) }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="selected_forecast_view === 'sales'" label="" width="150px">
                    <el-table-column :prop="efficiency_data" label="EFFICIENCY" width="150px">
                        <template slot-scope="scope">
                            <span>{{ scope.row.efficiency_data.efficiency }} %</span>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-container hidden">
            <el-pagination
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                @current-change="handleCurrentChange"
            />
        </div>
    </div>
</template>

<script>
import salesForecastMixin from '../../../../mixins/salesForecastMixin.js'
import moment from 'moment';
    export default {
        name: "SalesForecastLocation",
        mixins: [salesForecastMixin],
        data() {
            return {
                
            }
        },
        computed: {

        },
        mounted() {
            if (!Object.keys(this.$route.query).length) { return this.failed_page = true; };
            const view = this.$route.query.view;
            const start_date = this.$route.query.start_date;
            const end_date = this.$route.query.end_date;
            const store_id = localStorage.getItem("store_id");
            if (view && start_date && end_date && store_id) {
                this.handleStoreChange(store_id, { start_date, end_date }, view);
                this.getAllOutletsAction();
                console.log("calling times...")
            }
            // this.selected_local_date = this.selected_forecast_date;
        },
        beforeRouteUpdate() {

        },
        methods: {
            setCellClass({ row, column, rowIndex, columnIndex }) {
                console.log(row, column, rowIndex, columnIndex, 'row, column, rowIndex, columnIndex')
                if (column.label === 'FORECAST') {
                    return 'ns-forecast-forecast';
                }
            },
            formatCurrency(number){
                const result = new Intl.NumberFormat('en-IN').format(
                    number,
                );
                return result ? `INR ${result}` : 'INR 0';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ns--sf-table-container {
        width: 100%; /* Set a fixed width for the container */
        overflow-x: auto; /* Enable horizontal scrolling */
    }
</style>

<style>
    .ns--sf-table-container table tbody tr td{
        text-align: center !important;
    }
    .ns--sf-table-container .ns-table.el-table {
        border: none !important;
    }
    /* .ns--sf-table-container table tbody tr td:nth-child(3n) {
        border-right: 1px solid #ebeef5 !important;
    } */
    .ns--sf-table-container table tbody tr td:last-child {
        border-right: none !important;
    }
    .ns--sf-table-container .el-table--border::after, .ns--sf-table-container .el-table--group::after {
        width: 0 !important;
    }

    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr td:nth-child(7),
    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr:not(:first-child) th:nth-child(7){
        border-left: 1px solid #fcc793 !important;
        border-right: 1px solid #fcc793 !important;
        border-bottom: 1px solid #fcc793 !important;
        background: #fcdcbd3f;
    }
    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr td:nth-child(7).el-table__cell,
    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr td:nth-child(8).el-table__cell,
    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr td:nth-child(9).el-table__cell{
        border-bottom: 2px solid #fcc793 !important;
    }

    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr td:nth-child(8),
    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr:not(:first-child) th:nth-child(8),
    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr td:nth-child(9),
    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr:not(:first-child) th:nth-child(9){
        border-right: 1px solid #fcc793 !important;
        border-bottom: 1px solid #fcc793 !important;
        background: #fcdcbd3f;
    }
    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr th.ns-forecast-forecast{
        /* background: #f8ab6729 !important; */
        /* color: #fcc793 !important; */
        border-bottom: 1px solid #fcc793 !important;
        border-right: 1px solid #fcc793 !important;
        border-left: 1px solid #fcc793 !important;
        border-top: 1px solid #fcc793 !important;
        background: #fcdcbd3f;
    }
    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr:not(:first-child) th:nth-child(7),
    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr:not(:first-child) th:nth-child(8),
    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr:not(:first-child) th:nth-child(9),
    .LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-week-tbl table tr th.ns-forecast-forecast{
        background: #fcdcbd7c !important;
    }
</style>